export const SUPPLIER_STATUSES = ['Prospect', 'Active (Invoicing)', 'Inactive (Not Invoicing)'];

export const SUPPLIER_ACTIVE_PROSPECTIVE_STATUS = 'Active/Prospect';
export const SUPPLIER_ACTIVE_STATUS = 'Active (Invoicing)';
export const SUPPLIER_PROSPECTIVE_STATUS = 'Prospect';

export const ACTIVE_INVOICING_FILTER_NAME = SUPPLIER_ACTIVE_STATUS;

export const INITIAL_QUERY_STRING_SUPPLIER = `?invoiceStatus=${SUPPLIER_STATUSES.map(status => encodeURIComponent(status))}`;
